module.exports = __webpack_public_path__ + "img/gfit2.d980ebee.jpg";